import React from 'react';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import {
  RoadmapExecutiveSummaryContent,
} from 'Views/Page/Content/Templates/RoadmapExecutiveSummaryTemplate/RoadmapExecutiveSummary/RoadmapExecutiveSummaryContent';
import {
  RoadmapExecutiveSummarySkeleton,
} from 'Views/Page/Content/Templates/RoadmapExecutiveSummaryTemplate/RoadmapExecutiveSummarySkeleton';

const RoadmapExecutiveSummaryContainer = ({ relationship }) => {
  const {
    collection, loadingError, isInitializing,
  } = useLink(relationship.link('related'));

  return (
    <DataContainer
      component={RoadmapExecutiveSummaryContent}
      componentProps={{
        resource: collection?.resources()?.head(),
      }}
      loading={isInitializing}
      loadingError={loadingError}
      skeleton={RoadmapExecutiveSummarySkeleton}
    />
  );
};

export default RoadmapExecutiveSummaryContainer;
